import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "error"];
import { useQuery, registerQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { requestFetchPersonalizationVariants } from '../api/personalization';
const PersonalizationVariantsQuery = registerQuery({
  fieldName: 'personalizationVariants',
  args: ['id'],
  fetcher: requestFetchPersonalizationVariants
});
export const useFetchPersonalizationVariants = ({
  contentId,
  shouldFetch = true
}) => {
  const _useQuery = useQuery(PersonalizationVariantsQuery, {
      variables: {
        id: contentId
      },
      skip: !shouldFetch
    }),
    {
      data,
      loading,
      error
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  if (error) {
    Raven.captureMessage('[P13n] - Error fetching personalization variants', {
      extra: {
        error
      }
    });
  }
  return Object.assign({
    data,
    loading,
    error
  }, rest);
};